import { render } from "./slider-leaderboard.vue?vue&type=template&id=38fe7c5c&scoped=true&ts=true"
import script from "./slider-leaderboard.vue?vue&type=script&lang=ts"
export * from "./slider-leaderboard.vue?vue&type=script&lang=ts"

import "./slider-leaderboard.vue?vue&type=style&index=0&id=38fe7c5c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38fe7c5c"]])

export default __exports__